// src/api/adminMetricsApi.ts
// Adaptador de MÉTRICAS DE PLATAFORMA (super_admin) contra lealify-base (A1 / F13.7).
// Reemplaza esapi/Elasticsearch para el "home admin": /admin/global-metrics (OverallMetrics)
// y /admin/growth (GrowthMetrics). El backend ya devuelve los shapes camelCase tal cual,
// así que el adapter sólo tipa la respuesta de baseApi (cookie httpOnly, cross-tenant).
import { baseApi } from './baseClient';

// Métricas globales agregadas de la plataforma (ventana `range`).
export interface OverallMetrics {
  totalBusinesses: number;
  activeBusinesses?: number;
  totalClients: number;
  newClientsLast30Days: number;   // nombre histórico; usa la ventana `range`
  totalVisits: number;
  totalPointsAwarded: number;
  maleClients: number;
  femaleClients: number;
  unknownGenderCustomers: number;
  activeClients?: number;
  activeBranches?: number;
  activeRewardsCount?: number;
}

// Monetización del catálogo de negocios (cobros, riesgo, renovaciones).
export interface GrowthRevenue {
  arr: number;
  mrr: number;
  pagando: number;
  planPagando: { pro: number; premium: number };
  enPrueba: { id: string; name: string; plan: string; venceDias: number | null }[];
  propios: number;
  renovaciones: { id: string; name: string; plan: string; precio: number; antigMeses: number | null; venceDias: number | null; ultVisita?: number | null; ultReg?: number | null }[];
  proEnRiesgo?: { id: string; name: string; plan: string; precio: number; antigMeses: number | null; venceDias: number | null; ultVisita: number | null; ultReg: number | null }[];
}

// Catálogo de negocios por uso real + listas accionables.
export interface GrowthMetrics {
  total: number;
  seg: Record<string, number>;
  altas: { mes: string; n: number }[];
  candidatosPro: { id: string; name: string; vis: number; cli: number; dias: number; ultReg: number | null; altaDias: number | null }[];
  recuperar: { id: string; name: string; vis: number; cli: number; dias: number }[];
  activar: { id: string; name: string; diasAlta: number; onb: boolean }[];
  activosAhora: number;
  conversionPro: number;
  revenue?: GrowthRevenue;
}

export const adminMetricsApi = {
  // OverallMetrics — KPIs globales de la plataforma. range ∈ 7d|30d|90d.
  globalMetrics: (range: '7d' | '30d' | '90d' = '30d'): Promise<OverallMetrics> =>
    baseApi.get<OverallMetrics>(`/admin/global-metrics?range=${range}`),

  // GrowthMetrics — panel de crecimiento (catálogo + monetización).
  growth: (): Promise<GrowthMetrics> => baseApi.get<GrowthMetrics>('/admin/growth'),
};

export default adminMetricsApi;
